<div class="container-fluid">
  <ngx-alerts></ngx-alerts>
  <app-pagetitle
    [title]="'Customers with '+(name)"></app-pagetitle>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
                   style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
              <tr>
                <th>S.No.</th>
                <th>Name</th>
                <th>Phone Number</th>
                <th>Vehicle</th>
                <th *ngIf="search.isServiceReminders">Service Reminder Date</th>
                <th *ngIf="search.isInsuranceReminders">Insurance Reminder Date</th>
                <th *ngIf="search.isPollutionReminders">Pollution Check Reminder Date</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of alertCustomers; let i= index">

                <td>{{i + 1}}</td>
                <td>{{item.userFullName}}</td>
                <td>{{item.userPhoneNumber}}</td>
                <td>{{getVehicleName(item)}}</td>
                <td *ngIf="search.isServiceReminders">{{item.serviceReminderDate}}</td>
                <td *ngIf="search.isInsuranceReminders">{{item.insuranceReminderDate}}</td>
                <td *ngIf="search.isPollutionReminders">{{item.pollutionReminderDate}}</td>
              </tr>
              </tbody>
            </table>
            <mat-paginator (page)="pageEvent = getServerData($event)" [length]="totalRecords"
                           [pageSize]="search.size"
                           [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
